import Radium from "radium";

const STYLES = {
  container: {
    display: "flex",
    margin: "-0.5em",
    color: "#616161",
    flexWrap: "wrap"
  },
  well: {
    flex: 1,
    minWidth: 100,
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    textAlign: "center",
    cursor: "pointer",
    borderRadius: 5,
    padding: "1em",
    margin: "0.5em",
    boxShadow: "0px 0px 5px #ccc",
    transition: "0.2s all ease-in-out",
    ":hover": {
      boxShadow: "rgb(2, 94, 209) 0px 0px 5px"
    }
  },
  selected: {
    boxShadow: "rgb(2, 94, 209) 0px 0px 10px",
    ":hover": {
      boxShadow: "rgb(2, 94, 209) 0px 0px 10px"
    }
  },
  disabled: {
    backgroundColor: "rgb(229, 229, 229)",
    boxShadow: "none",
    cursor: "not-allowed",
    color: "rgba(33, 33, 33, 0.3)",
    ":hover": {
      boxShadow: "none"
    }
  },
  icon: {
    width: 50,
    height: 50,
    color: "#616161",
    verticalAlign: "-18px"
  },
  label: {
    fontSize: "1.4em",
    marginLeft: "0.5em",
    display: "inline-block"
  },
  sublabel: {
    fontSize: "1em",
    marginTop: "0.5em",
    lineHeight: "1em"
  },
  labelWithSublabel: {
    display: "block",
    marginLeft: 0
  }
};

const SelectWells = ({ style, options, value, onChange }) => {
  return (
    <div style={[STYLES.container, style]}>
      {options.map(o => {
        return (
          <div
            key={o.value}
            style={[
              STYLES.well,
              value === o.value && STYLES.selected,
              o.disabled && STYLES.disabled
            ]}
            onTouchTap={() => !o.disabled && onChange(o.value)}
          >
            <div>
              {o.icon && (
                <o.icon
                  style={Object.assign(
                    {},
                    STYLES.icon,
                    o.disabled && STYLES.disabled
                  )}
                />
              )}
              {o.label && (
                <div
                  style={[
                    STYLES.label,
                    o.disabled && STYLES.disabled,
                    o.sublabel && STYLES.labelWithSublabel
                  ]}
                >
                  {o.label}
                </div>
              )}
              {o.sublabel && (
                <div style={[STYLES.sublabel, o.disabled && STYLES.disabled]}>
                  {o.sublabel}
                </div>
              )}
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default Radium(SelectWells);



// WEBPACK FOOTER //
// ./src/app/components/partials/select-wells.jsx